const Analytics = require ('../class/analytics.js');
let localhost = `localhost`//`jcae.guardian.alicesecurity.co`;
let port      = `9090`//process.env.VUE_APP_PORT_API    || `80`; 
const axios     = require ('axios');
const api       = require("../api.js")
// console.log("API Modules ............................ ", api )
let URL         = 'http://' + localhost + ':' + port;
if (api) {
  URL = api.url;
}

axios.defaults.withCredentials   =   false;

class Modules extends Analytics {
	constructor(modules, module_default, analytics, analytics_default, associates, currentUser, devices){
    // console.log("class modules **************************** ")
		super(modules, module_default, analytics, analytics_default, associates, currentUser, devices);
    /*this.modules           = modules;
    this.module_default    = module_default;
    this.analytics         = analytics;
    this.analytics_default = analytics_default;
    this.currentUser       = currentUser*/
    
	}
  add_request(location, port){
    localhost = location;
    port = port;   
  }

  update_list(list, opt){
    // console.log("update list module : ", opt)
    if (list && list.length > 0) {
      this[opt] = list;
    }
  } // update_list

  renderEnableModule(listModulesActives, listModulesInactives ){
    // console.log(listModulesActives, listModulesInactives )
    // General parameters
    let roleId = 3
    if (this.currentUser && this.currentUser.user) {
      roleId = this.currentUser.user.roleId;
    }
    let list_installeds = {};
    if (localStorage.getItem('General_parameters')){
      list_installeds          =  JSON.parse(localStorage.getItem('General_parameters'));
    }else{
      list_installeds          =  this.module_default;          
    }
    // for
    if (list_installeds && list_installeds.modules && list_installeds.modules.length > 0){      
      list_installeds.modules.forEach((it, idx)=>{
        if (it) {          
            let tempIt    = it.enable
            it.enable = listModulesActives.includes(it.module) ? true : listModulesInactives.includes(it.module) ? false : tempIt;
            it.permission_user = it.enable;
        // console.log(" it ", it)
          if (it.sub_modules && it.sub_modules.length > 0) {
            it.sub_modules.forEach((sub, idxSub)=>{
              if (sub && typeof sub == "object") {
                let tempSub = sub.enable;
                sub.enable = listModulesActives.includes(sub.module) ? true : listModulesInactives.includes(sub.module) ? false : tempSub;
                sub.permission_user = sub.enable;
              }
            });
          }
          if (it.associates && it.associates.length > 0) {

            it.associates.forEach((asso, idxSub)=>{
              if (asso && typeof asso == "object") {
                let tempAsso = asso.enable;
                asso.enable = listModulesActives.includes(asso.module) ? true : listModulesInactives.includes(asso.module) ? false : tempAsso;
                asso.permission_user = asso.enable;
                
              }
            }); 
          }
        
        }
      })
      
      this.list_modules   = list_installeds.modules;
      this.save_modules(list_installeds, 'General_parameters');
      this.modules    = list_installeds;
      return list_installeds;
    }
  }

	module_render(item, type, count = false, license ){ 
        /* 
          item    = analytic , 
          type    = option = 'new_device', 
          licence = activate license*/
          // console.log("init states render modules ********************** ", item, type, license);
          // console.log("currentUser : ************** ", this.currentUser)
          if (this.currentUser) {
            // get current user
            let search_role     = this.currentUser.user.roleId; // this.$store.state.auth.user
            let list_components = [];

            //  default if no fount current
            if (!search_role) {
              search_role       = 3;
            }
          let list_installeds       = []; // modules

          // General parameters
          if (localStorage.getItem('General_parameters')){
            list_installeds          =  JSON.parse(localStorage.getItem('General_parameters'));
          }else{
            list_installeds          =  this.module_default;          
          }

          // Analytics
          list_components         = this.list_licences;
            // console.log('************************* list_licences  and parameters', list_components, list_default);


          let component           = item; // if have item
          let sw_component        = false; // check if exist item
          let len                 = 0;
          if (list_installeds && list_installeds.modules && list_installeds.modules.length > 0){
            len                   = list_installeds.modules.length;

            for (let i = 0; i < len; i++) {
              if( list_installeds.modules[i].module == item /*&& 
                !list_installeds.modules[i].enable*/ && (type == 'new_module' || type == 'active')){

                // enable module
              list_installeds.modules[i].enable = true;

                // console.log(list_installeds.modules[i], '********************************** Module');
                // enable views sidebar
                if (list_installeds.modules[i].sub_modules && list_installeds.modules[i].sub_modules.length > 0) {
                  // console.log("***************** SUBMODULES")
                  let j = 0;
                  while (j <=  list_installeds.modules[i].sub_modules.length){
                      // console.log(list_installeds.modules[i].sub_modules[j], "SUBMODULES ****************** 1")
                      const find = list_installeds.modules.some(function(arr_sub, idx_sub){
                        if (list_installeds.modules[i].sub_modules[j] == arr_sub.module) {
                          if (arr_sub.type) {
                            list_installeds.modules[idx_sub].enable = true;
                          }
                        }
                      })
                      j++;
                    }
                  }


              } // new module

              if (list_installeds.modules[i].enable) {
                if (type == 'new_module' && !sw_component){
                  sw_component = true;
                }
                
                let temp  = (list_installeds.modules[i].roles).indexOf(search_role)

                // console.log('result :', temp,' role to search: ', search_role, ' is able: ',list_installeds.modules[i].roles, 'searching')
                if (temp != -1) {
                  list_installeds.modules[i].permission_user = true;
                }else{
                  list_installeds.modules[i].permission_user = false;
                }

              } // enable user permission
            } // for modules
          }

          let vm              = this;

          // active options analytics for routes and components
          if (sw_component && list_components && list_components.length > 0) {

            const find = list_components.some( function(arr_comp, idx_comp){
              if (arr_comp.key == component) {
                arr_comp.active = true;
                // console.log("COUNT *************************** ", arr_comp.count);
                if (count){
                  arr_comp.count++;
                }

                return true;
              }
            })

          }
          // console.log(' list analytics *************** ', list_components)

          if (list_installeds && list_installeds.modules && list_installeds.modules.length>0) {

            vm.list_modules   = list_installeds.modules;
            this.save_modules(list_installeds, 'General_parameters');
            if (type == 'new_module') {
              this.update_parameters(list_installeds, 'modules')
              this.update_parameters(list_components, 'analytics')
            }
          }
          this.save_modules(list_components, 'Analytics');
          this.update_list(list_installeds, '')
          // save associate device - analytic
          if (license) {
            this.save_associate('update', license); 
          }

          this.modules    = list_installeds;
          this.analytics  = list_components;
          return list_installeds;
        }
  } // module render

      delete_modules(item){ // for check and delete module and analytic
          // let result = this.searcher([{num: 1},{ num:2},{ num:3}],'num',2 );
          // item = device
          // console.log("ITEM TO DELETE ", item)
          let list_analytics = this.list_licences,
          list_module   = this.list_modules;

          if (item && item.length > 0) {
            let len = item.length;
            let i   = 0;
            // check analytic
            while (i <= len){

              let check_module    = false,
              result          = null ;
              if (item[i].type) {

                result = this.searcher(list_analytics, item[i].type,'key' );
                if (result) {
                  // console.log(result,"******************* RESULT TO delete")
                  if (list_analytics[result.idx].count > 0){
                    list_analytics[result.idx].count--;            
                  }
                  if (list_analytics[result.idx].count == 0) {}{
                    list_analytics[result.idx].active = false;
                    check_module = true;
                  }

                  if (check_module) {
                    let  result_module = this.searcher(list_module, item[i].type, 'module');
                    // console.log(result_module, "***************** RESULT Module");
                    if (result_module) {
                      list_module[result_module.idx].enable = false;
                    }
                  }
                }
              } // type
              i++;
            } // while
          } // item
          this.save_modules(list_analytics, 'Analytics');
          this.save_modules(list_module, 'General_parameters');
          this.update_parameters(list_analytics, 'analytics')
          this.update_parameters(list_module, 'modules')
          const timer_module = setTimeout( () =>{
            this.module_render();
          }, 1200)


          // console.log(result);
      }  //delete analytic

    reset_modules(){ // just when deleted all 
    if (this.module_default && this.module_default.modules && this.module_default.modules.length > 0){
      this.save_modules(this.module_default, 'General_parameters');
    }
    if (this.analytics_default && this.analytics_default.length > 0){
      this.save_modules(analytics_default, 'Analytics');
    }
    if (localStorage.getItem('Device_Analytics')) {
      localStorage.removeItem('Device_Analytics');
    }

  } // reset modules

  save_modules(items, opt){
      // let list=null;
     /*
      'General_parameters' / modules
      'Analytics' /
      'Device_Analytics' / Associate 
      */
      if (items && opt) {                
        localStorage.setItem(opt, JSON.stringify(items));
      }
      // console.log("SAVE MODULES ***************** ", opt, items)
  } // save modules


      

      delete_modules(item){ // for check and delete module and analytic
          // let result = this.searcher([{num: 1},{ num:2},{ num:3}],'num',2 );
          // item = device
          // console.log("ITEM TO DELETE ", item)
          let list_analytics = this.list_licences,
          list_module   = this.list_modules;

          if (item && item.length > 0) {
            let len = item.length;
            let i   = 0;
            // check analytic
            while (i <= len){

              let check_module    = false,
              result          = null ;
              if (item[i] && item[i].type) {

                result = this.searcher(list_analytics, item[i].type,'key' );
                if (result) {
                  // console.log(result,"******************* RESULT TO delete")
                  if (list_analytics[result.idx].count > 0){
                    list_analytics[result.idx].count--;            
                  }
                  if (list_analytics[result.idx].count == 0){
                    list_analytics[result.idx].active = false;
                    check_module = true;
                  }

                  if (check_module) {
                    let  result_module = this.searcher(list_module, item[i].type, 'module');
                    // console.log(result_module, "***************** RESULT Module");
                    if (result_module) {
                      list_module[result_module.idx].enable = false;
                    }
                  }
                }
              } // type
              i++;
            } // while
          } // item
          this.save_modules(list_analytics, 'Analytics');
          this.save_modules(list_module, 'General_parameters');
          this.update_parameters(list_analytics, 'analytics')
          const time = setTimeout( ()=>{

        
            clearTimeout(time);
          }, 2000)
          const timer_module = setTimeout( () =>{
            this.module_render();
            clearTimeout(timer_module);
          }, 100)


          // console.log(result);
      }  //delete analytic


      update_parameters(items , parameter){
        const api   = URL + '/api/v1/parameters/';
        let info_up = {
          parameter,
          parameters: items
        }
        axios.put(api + parameter, info_up).then( res => {
          console.log("update parameters : ", res)
        }).catch( er => {
          console.log("Error update parameters : ", er)
        })
      } // update parameters

}

module.exports = Modules;